// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyA2PbCBywDGd28iVnXrHBOsWlCWggyUgFs",
    authDomain: "facebook-clone-8d028.firebaseapp.com",
    projectId: "facebook-clone-8d028",
    storageBucket: "facebook-clone-8d028.appspot.com",
    messagingSenderId: "287652357400",
    appId: "1:287652357400:web:f4b1e44c1d7d8953356a6d",
    measurementId: "G-S47WNBZDVB"
  };

  const firebaseApp= firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth, provider};
  export default db;